export const SX = '\x02';
export const EB = '\x17';
export const SH = '\x01';
// export const EB = '\x0F' // marche avec 2100 ?
export const ET = '\x04';
// SX  = start of text (STX) used to indicate the start of a sentence
// SH = start of header (SOH) used to indicate the start of a header
// EB = end of block (EOB) used to indicate the end of a block, for example end of a DRM block
// ET = end of transmission (EOT) used to indicate the end of a transmission